const ageArray = [];

let startYear = new Date().getFullYear() - 18;

for (let i = 1; i <= 110; i++) {
    ageArray.push({
        value: `${startYear.toString()}`,
        label: startYear.toString(),
    });

    startYear -= 1;
}

export default ageArray;
